define([
	"dojo/_base/declare",
	"csi/html",
	"csi/widget/FilteringSelect",
	"./ToolbarPlugin"
], function(declare,html,FilteringSelect,ToolbarPlugin) {

	return declare([FilteringSelect, ToolbarPlugin], {
		// String: label to show in front of select widget
		//label: "",

		// Boolean: indicate if label should be displayed
		//showLabel: false,

		postMixInProperties: function() {
			// summary: set properties based on action
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		startup: function() {
			// summary: add label if needed
			this.inherited(arguments);

			if (this.get("showLabel")) {
				html.create("label", {
					"class": "dijitInline",
					innerText: this.get("label") + ":"
				}, this.domNode, "before");
			}
		},

		onChange: function(/*Object*/value, /*Action?*/action) {
			// summary: only send change events for values that are in store, otherwise UI will just revert to original value
			if (this.store && this.store.get(value)) {
				this.inherited(arguments);
			}
		}
	});
});